var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:_vm.cartButton.class,attrs:{"type":"button"},on:{"click":function($event){return _vm.cartButton.clickEvent()}}},[_vm._v(" "+_vm._s(_vm.cartButton.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }